import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import {
    faHouseUser,
    faKey,
    faMoneyBillAlt,
    faSearchDollar,
    faTools,
    faUniversity,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { MapLike } from "typescript";
import {
    IAtividadeNotificacao,
    IAtividadeNotificacaoPorModulo,
} from "../../../../Interfaces/Geral/Notificacao/NotificacaoInterfaces";
import { ListarAtividadesNotificacaoUsuarioPorModulo } from "../../../../Controllers/Geral/Notificacao/NotificacaoControllers";
import { ACESSOS } from "../../../../Routes/Acessos";
import { Spinner } from "../../../Loding/SpinnerPadrao";
import { Link } from "react-router-dom";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SpinnerComponent from "../../../Loding/Spinner";
import { useAtedimento } from "../../../../Context/Atendimento";

interface IAtendimentosModuloProps {
    lstAtividadesAtendimento: Array<IAtividadeNotificacao> | undefined;
}

interface IAtividadeNotificacaoComAtendimentos extends IAtividadeNotificacao {
    atendimetos?: Array<IAtividadeNotificacaoPorModulo>;
}

interface IModuloDados {
    icon: IconProp;
    color: string;
    urlGestao?: string;
    linkAtendimento?: (idCaso: number) => string;
}

const moduloIcon: MapLike<IModuloDados> = {
    [ACESSOS.ATENDIMENTO.ID_MODULO]: {
        icon: faUsers,
        color: "danger",
        urlGestao:
            ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS
                .DS_PATH,
        linkAtendimento: ACESSOS.ATENDIMENTO.TELAS.ATENDIMENTO.DS_LINK,
    },
    [ACESSOS.COBRANCA.ID_MODULO]: {
        icon: faSearchDollar,
        color: "warning",
        urlGestao: ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.DS_PATH,
        linkAtendimento: ACESSOS.COBRANCA.TELAS.ATENDIMENTO.DS_LINK,
    },
    [ACESSOS.HELPDESK.ID_MODULO]: {
        icon: faWhatsapp,
        color: "success",
        urlGestao: ACESSOS.HELPDESK.TELAS.ATENDIMENTO.DS_PATH,
        linkAtendimento: () => ACESSOS.HELPDESK.TELAS.ATENDIMENTO.DS_PATH,
    },
    [ACESSOS.REPASSE.ID_MODULO]: {
        icon: faUniversity,
        color: "info",
        urlGestao:
            ACESSOS.REPASSE.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS.DS_PATH,
        linkAtendimento: ACESSOS.REPASSE.TELAS.ATENDIMENTO.DS_LINK,
    },
    [ACESSOS.ASSISTENCIA.ID_MODULO]: {
        icon: faTools,
        color: "primary",
        urlGestao: undefined,
        linkAtendimento: ACESSOS.ASSISTENCIA.TELAS.ATENDIMENTO.DS_LINK,
    },
    [ACESSOS.VENDAS.ID_MODULO]: {
        icon: faMoneyBillAlt,
        color: "dark",
        urlGestao:
            ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS.DS_PATH,
        linkAtendimento: ACESSOS.VENDAS.TELAS.ATENDIMENTO.DS_LINK,
    },
    [ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO]: {
        icon: faKey,
        color: "dark",
        urlGestao: undefined,
        linkAtendimento: ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTO.DS_LINK,
    },
    7: {
        // pós ocupacional
        icon: faHouseUser,
        color: "dark",
        urlGestao: undefined,
        linkAtendimento: undefined,
    },
};

export default function AtendimentosModulo(props: IAtendimentosModuloProps) {
    const [collapse, setCollapse] = useState(-1);
    const [lstAtividadesAtendimentos, setLstAtividadesAtendimentos] =
        useState<Array<IAtividadeNotificacaoComAtendimentos>>();

    const { FL_MODO_ATENDIMENTO_BLOQUEIO } = useAtedimento();

    useEffect(() => {
        setLstAtividadesAtendimentos(props.lstAtividadesAtendimento);
    }, [props.lstAtividadesAtendimento]);
    return (
        <>
            <Accordion
                activeKey={`${collapse}`}
                className="navi navi-hover my-3"
            >
                {lstAtividadesAtendimentos ? (
                    lstAtividadesAtendimentos.length ? (
                        lstAtividadesAtendimentos.map((modulo) => {
                            const urlGestao =
                                moduloIcon[modulo.ID_TIPO_CASO].urlGestao;
                            return (
                                <div
                                    className="d-flex flex-column align-items-center navi-item"
                                    key={modulo.ID_TIPO_CASO}
                                    role="button"
                                >
                                    <div
                                        className="navi-link w-100"
                                        onClick={() => {
                                            setCollapse(
                                                collapse === modulo.ID_TIPO_CASO
                                                    ? -1
                                                    : modulo.ID_TIPO_CASO
                                            );
                                            if (!modulo.atendimetos) {
                                                ListarAtividadesNotificacaoUsuarioPorModulo(
                                                    modulo.ID_TIPO_CASO
                                                ).then((res) => {
                                                    const arrayAtividades =
                                                        Array.from(
                                                            lstAtividadesAtendimentos
                                                        );
                                                    const atividade =
                                                        arrayAtividades.find(
                                                            (m) =>
                                                                m.ID_TIPO_CASO ===
                                                                modulo.ID_TIPO_CASO
                                                        );
                                                    if (atividade)
                                                        atividade.atendimetos =
                                                            res;
                                                    setLstAtividadesAtendimentos(
                                                        arrayAtividades
                                                    );
                                                });
                                            }
                                        }}
                                    >
                                        <div
                                            className={`symbol symbol-40 symbol-light-${
                                                moduloIcon[modulo.ID_TIPO_CASO]
                                                    ?.color
                                            } mr-5`}
                                        >
                                            <span className="symbol-label">
                                                <span className="svg-icon svg-icon-lg svg-icon-primary">
                                                    <FontAwesomeIcon
                                                        icon={
                                                            moduloIcon[
                                                                modulo
                                                                    .ID_TIPO_CASO
                                                            ]?.icon
                                                        }
                                                    />
                                                </span>
                                            </span>
                                        </div>
                                        <div className="d-flex flex-column font-weight-bold">
                                            <span className="text-dark text-hover-primary mb-1 font-size-lg">
                                                {modulo.DS_TIPO_CASO}
                                            </span>
                                            <span className="text-muted">
                                                {modulo.NR_ATENDIMENTOS_ABERTOS}{" "}
                                                Atendimentos
                                            </span>
                                        </div>
                                    </div>
                                    <Accordion.Collapse
                                        eventKey={`${modulo.ID_TIPO_CASO}`}
                                        className="w-100"
                                    >
                                        {modulo.atendimetos ? (
                                            <div className="w-100 p-7">
                                                <div>
                                                    <div>
                                                        {modulo.atendimetos
                                                            .length ? (
                                                            modulo.atendimetos.map(
                                                                (
                                                                    atendimento
                                                                ) => {
                                                                    const linkAtendimento =
                                                                        moduloIcon[
                                                                            modulo
                                                                                .ID_TIPO_CASO
                                                                        ]
                                                                            .linkAtendimento;
                                                                    return (
                                                                        <span
                                                                            key={
                                                                                atendimento.ID_CASO
                                                                            }
                                                                        >
                                                                            <div className="d-flex justify-content-between w-100">
                                                                                <span>
                                                                                    <div className="font-weight-bolder font-size-h6">
                                                                                        {
                                                                                            atendimento.DS_CONTA
                                                                                        }
                                                                                    </div>
                                                                                    <div className="text-muted">
                                                                                        {
                                                                                            atendimento.DS_CONTATO
                                                                                        }
                                                                                    </div>
                                                                                </span>
                                                                                <span className="d-flex flex-column ">
                                                                                    {atendimento.DS_CATEGORIA_ATENDIMENTO && (
                                                                                        <OverlayTrigger
                                                                                            overlay={
                                                                                                <Tooltip id="tooltip-catAtendimento">
                                                                                                    Categoria
                                                                                                    de
                                                                                                    atendimento
                                                                                                </Tooltip>
                                                                                            }
                                                                                        >
                                                                                            <span className="label label-sm label-light-danger label-inline mr-2 my-1">
                                                                                                {
                                                                                                    atendimento.DS_CATEGORIA_ATENDIMENTO
                                                                                                }
                                                                                            </span>
                                                                                        </OverlayTrigger>
                                                                                    )}

                                                                                    {linkAtendimento && (
                                                                                        <span className="text-right">
                                                                                            <Link
                                                                                                target={
                                                                                                    FL_MODO_ATENDIMENTO_BLOQUEIO
                                                                                                        ? "__blank"
                                                                                                        : ""
                                                                                                }
                                                                                                to={linkAtendimento(
                                                                                                    atendimento.ID_CASO
                                                                                                )}
                                                                                                className="btn btn-light-primary font-weight-bold text-center label label-light-primary label-inline mr-2 my-1"
                                                                                            >
                                                                                                Ver
                                                                                            </Link>
                                                                                        </span>
                                                                                    )}
                                                                                </span>
                                                                            </div>
                                                                            <hr />
                                                                        </span>
                                                                    );
                                                                }
                                                            )
                                                        ) : (
                                                            <div className="text muted text">
                                                                Nenhum
                                                                Atendimento
                                                                nesse módulo
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                {urlGestao && (
                                                    <Link
                                                        to={urlGestao}
                                                        className="btn btn-light-primary font-weight-bold text-center"
                                                        onClick={() => {
                                                            setCollapse(-1);
                                                        }}
                                                        target={
                                                            FL_MODO_ATENDIMENTO_BLOQUEIO
                                                                ? "__blank"
                                                                : ""
                                                        }
                                                    >
                                                        Ver todos
                                                    </Link>
                                                )}
                                                <div className="w-100 d-flex justify-content-center mt-2"></div>
                                            </div>
                                        ) : (
                                            <div className="w-100 text-center my-2">
                                                <Spinner color="primary" />
                                            </div>
                                        )}
                                    </Accordion.Collapse>
                                </div>
                            );
                        })
                    ) : (
                        <div className="text-muted text-center">
                            Nenhum Atendimento Aberto
                        </div>
                    )
                ) : (
                    <SpinnerComponent />
                )}
            </Accordion>
        </>
    );
}
